import { UserLevel } from "utils/constant";

export const getBkkUserValue = (currentUser) =>
  currentUser?.username
    ? `${currentUser.username}|${currentUser.first_name}`
    : "";

export const resolveLevelIdOnLevelChange = ({
  nextLevel,
  currentUser,
  selectedInduk,
  selectedWilker,
}) => {
  if (nextLevel === UserLevel.National) {
    return "";
  }

  if (nextLevel === UserLevel.BKKInduk) {
    if (selectedInduk && String(selectedInduk).includes("|")) {
      return selectedInduk;
    }
    if (currentUser?.level === UserLevel.BKKInduk) {
      return getBkkUserValue(currentUser);
    }
    return "";
  }

  if (nextLevel === UserLevel.BKKWilker) {
    if (selectedWilker) {
      return selectedWilker;
    }
    if (
      currentUser?.level === UserLevel.BKKWilker ||
      currentUser?.level === UserLevel.BKKInduk
    ) {
      return getBkkUserValue(currentUser);
    }
    return "";
  }

  const scopedDefaults = {
    [UserLevel.Fasyankes]: currentUser?.fasyankes_id,
    [UserLevel.District]: currentUser?.district_id,
    [UserLevel.Province]: currentUser?.province_id,
  };

  return scopedDefaults[nextLevel] || "";
};

export const resolveLevelIdForApply = ({
  selectedLevel,
  levelIdValue,
  selectedInduk,
  selectedWilker,
}) => {
  if (selectedLevel === UserLevel.BKKInduk) {
    return selectedInduk || levelIdValue || "";
  }
  if (selectedLevel === UserLevel.BKKWilker) {
    return selectedWilker || levelIdValue || "";
  }
  return levelIdValue || "";
};
